
import React, { useState } from "react";

import {
  createEncryptionKey,
  unlockEncryptionKey,
  encryptValue,
  decryptValue,
  isEncrypted,
} from "./encryptiondata";

export default function EncryptionTest() {
  const [result, setResult] = useState("Not tested");
  const [error, setError] = useState("");

  async function runTest() {
    setResult("Testing...");
    setError("");

    try {
      const clientId = 1;
      const passphrase = "WheelsERP-Test-Key-2026!";
      const original = "Test Customer";

      const { encryptionKey, bundle } =
        await createEncryptionKey(passphrase, clientId);

      const context = {
        clientId,
        table: "customers",
        column: "customername",
      };

      const encrypted = await encryptValue(
        original,
        encryptionKey,
        context
      );

      const decrypted = await decryptValue(
        encrypted,
        encryptionKey,
        context
      );

      const unlockedKey = await unlockEncryptionKey(
        passphrase,
        bundle,
        clientId
      );

      const decryptedAfterUnlock = await decryptValue(
        encrypted,
        unlockedKey,
        context
      );

      if (
        decrypted !== original ||
        decryptedAfterUnlock !== original ||
        !isEncrypted(encrypted)
      ) {
        throw new Error("A test did not return the expected result.");
      }

      setResult(
        [
          "PASS: Encryption successful",
          `Encrypted format detected: ${isEncrypted(encrypted)}`,
          `Decrypted value: ${decrypted}`,
          `Decrypted after unlocking: ${decryptedAfterUnlock}`,
          "All tests passed.",
        ].join("\n")
      );
    } catch (err) {
      setError(err.message || "Encryption test failed.");
      setResult("FAILED");
    }
  }

  return (
    <div style={{ padding: 24 }}>
      <h2>WheelsERP Encryption Test</h2>

      <button onClick={runTest}>
        Run Encryption Test
      </button>

      <pre style={{ whiteSpace: "pre-wrap", marginTop: 16 }}>
        {result}
      </pre>

      {error && (
        <p style={{ color: "red" }}>
          Error: {error}
        </p>
      )}
    </div>
  );
}
